// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Comoros from '../_raw/flag/icon_flag_comoros.png';

export default () => <img src={Comoros} alt="Comoros" />;
